import { IComponentMapperModel } from '@wix/editor-elements-types';

const MAPPER_EXTENSION = '.mapper.ts';
const PREVIEW_MAPPER_EXTENSION = '.previewMapper.ts';

const componentEntriesContext = require.context(
  './components',
  true,
  /mapper\.ts$/i,
);

type MapperConvention =
  | typeof MAPPER_EXTENSION
  | typeof PREVIEW_MAPPER_EXTENSION;

function getComponentName(path: string, convention: MapperConvention) {
  return path
    .split('/')
    .pop()!
    .replace(convention, '');
}

const isEditorMapper = (path: string) => path.includes('editorMapper');
const getMappingFunction = (convention: MapperConvention) => (
  acc: Record<string, any>,
  filePath: string,
) => {
  const componentName = getComponentName(filePath, convention);
  acc[componentName] = componentEntriesContext(filePath).default;
  return acc;
};

const componentMapperEntries = componentEntriesContext
  .keys()
  .filter(path => !isEditorMapper(path))
  .reduce<Record<string, IComponentMapperModel>>(
    getMappingFunction(MAPPER_EXTENSION),
    {},
  );

const componentEditorMapperEntries = componentEntriesContext
  .keys()
  .filter(isEditorMapper)
  .reduce<Record<string, IComponentMapperModel>>(
    getMappingFunction(PREVIEW_MAPPER_EXTENSION),
    {},
  );

export { componentEditorMapperEntries };
export default componentMapperEntries;
